import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebase/config";
import { collection, query, where, getDocs, orderBy, Timestamp } from "firebase/firestore";
import { useAuth } from "../../../context/AuthContext";
import { useTheme } from "../../../context/ThemeContext";
import Header from "../../../components/Header";

export default function Trazabilidad() {
  const { currentUser, userRole, clinicaId, clinicaData } = useAuth();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [acciones, setAcciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroUsuario, setFiltroUsuario] = useState('');
  const [filtroModulo, setFiltroModulo] = useState('');
  const [periodo, setPeriodo] = useState('hoy');

  const inputStyle = { padding: '8px 12px', fontSize: '13px', border: `0.5px solid ${theme.borderInput}`, borderRadius: '8px', outline: 'none', color: theme.primary, background: theme.bgInput, fontFamily: "'Montserrat', sans-serif" };

  useEffect(() => {
    if (!clinicaId) return;
    async function cargar() {
      setLoading(true);
      const ahora = new Date();
      let inicio = new Date();
      if (periodo === 'hoy') { inicio.setHours(0,0,0,0); }
      else if (periodo === 'semana') { inicio.setDate(ahora.getDate() - 7); }
      else if (periodo === 'mes') { inicio.setDate(1); inicio.setHours(0,0,0,0); }

      const q = query(
        collection(db, 'trazabilidad'),
        where('clinicaId', '==', clinicaId),
        where('fecha', '>=', Timestamp.fromDate(inicio)),
        orderBy('fecha', 'desc')
      );
      const snap = await getDocs(q);
      setAcciones(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }
    cargar();
  }, [clinicaId, periodo]);

  const accionesFiltradas = acciones.filter(a =>
    (!filtroUsuario || a.usuario?.toLowerCase().includes(filtroUsuario.toLowerCase())) &&
    (!filtroModulo || a.modulo === filtroModulo)
  );

  const modulos = [...new Set(acciones.map(a => a.modulo).filter(Boolean))];

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, fontFamily: "'Montserrat', sans-serif" }}>
      <Header titulo="Trazabilidad" backLabel="Usuarios" backRuta="/usuarios" />
      <div style={{ padding: '24px', background: theme.bg }}>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
          {['hoy', 'semana', 'mes'].map(p => (
            <button key={p} onClick={() => setPeriodo(p)} style={{
              padding: '6px 12px', fontSize: '12px', borderRadius: '8px', cursor: 'pointer',
              border: periodo === p ? 'none' : `0.5px solid ${theme.borderInput}`,
              background: periodo === p ? theme.accent : 'transparent',
              color: periodo === p ? '#FFFFFF' : theme.secondary,
              fontFamily: "'Montserrat', sans-serif"
            }}>
              {p === 'hoy' ? 'Hoy' : p === 'semana' ? '7 días' : 'Este mes'}
            </button>
          ))}
          <input value={filtroUsuario} onChange={e => setFiltroUsuario(e.target.value)} placeholder="Filtrar por usuario..." style={inputStyle} />
          <select value={filtroModulo} onChange={e => setFiltroModulo(e.target.value)} style={inputStyle}>
            <option value="">Todos los módulos</option>
            {modulos.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
          <span style={{ fontSize: '12px', color: theme.secondary, marginLeft: 'auto' }}>{accionesFiltradas.length} registros</span>
        </div>

        {loading
          ? <div style={{ textAlign: 'center', color: theme.secondary, padding: '48px' }}>Cargando...</div>
          : accionesFiltradas.length === 0
            ? <div style={{ textAlign: 'center', color: theme.secondary, padding: '48px', fontSize: '13px' }}>No hay registros</div>
            : <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {accionesFiltradas.map(a => {
                  const fecha = a.fecha?.toDate ? a.fecha.toDate().toLocaleString('es-AR') : '—';
                  return (
                    <div key={a.id} style={{ background: theme.bgCard, borderRadius: '8px', padding: '10px 14px', border: `0.5px solid ${theme.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '13px', color: theme.primary, fontWeight: '500' }}>{a.accion}</div>
                        <div style={{ fontSize: '11px', color: theme.secondary }}>{a.detalle}</div>
                      </div>
                      <div style={{ textAlign: 'right', flexShrink: 0 }}>
                        <div style={{ fontSize: '11px', color: theme.accent }}>{a.modulo}</div>
                        <div style={{ fontSize: '11px', color: theme.secondary }}>{a.usuario} · {fecha}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
        }
      </div>
    </div>
  );
}